import { useCopyToClipboard } from "@spiriidk/utils";
import { Check, Copy } from "lucide-react";
import React from "react";

import { Button, type ButtonProps } from "../button";

export interface CopyButtonProps extends Omit<
  ButtonProps,
  "children" | "asChild"
> {
  value: string;
}

function CopyButton({ value, onClick, ...props }: Readonly<CopyButtonProps>) {
  const { copy, copied } = useCopyToClipboard({ resetDelayMs: 2000 });

  return (
    <Button
      type="button"
      data-slot="copy-button"
      data-copied={copied || undefined}
      variant="muted"
      size="smaller-icon"
      {...props}
      onClick={(e) => {
        // onClick is extracted from props so it doesn't override this handler via spread.
        copy(value).catch(() => undefined);
        onClick?.(e);
      }}
    >
      {copied ? <Check className="size-3" /> : <Copy className="size-3" />}
    </Button>
  );
}

export { CopyButton };
